// A purchase is confirmed by what the SERVER reports (get-subscription-details), never by
// comparing against the tier the page started with: the paid Web Billing subscription is the
// plan the user just bought, or the account is active (not promotional) on that tier or above.
export const PLAN_RANK = { free: 0, advanced: 1, elite: 2 };

export const isPurchaseConfirmed = (details, planId) => {
  if (!details || PLAN_RANK[planId] === undefined) return false;
  if (details.web_subscription?.tier === planId) return true;
  const rank = PLAN_RANK[details.tier?.toLowerCase()];
  return (
    details.subscription_status === 'active' &&
    details.is_promotional !== true &&
    rank !== undefined &&
    rank >= PLAN_RANK[planId]
  );
};

// A promo -> paid switch is finished when the server says so FOR THE PLAN IT ACTUALLY ACTIVATED
// (promo_switch.state === 'done' with that confirmed tier), or when it already reports that paid
// plan and no promotional access. A switch that ended on another plan never confirms this one.
export const isPromoSwitchFinished = (details, planId) => {
  if (!details) return false;
  const operation = details.promo_switch;
  if (operation?.state === 'done') {
    const activated = operation.confirmed_tier || details.web_subscription?.tier;
    if (activated === planId) return true;
  }
  return details.web_subscription?.tier === planId && details.is_promotional !== true;
};

// Promo + a paid plan the user already has (e.g. a promo redeemed on top of a paid plan): moving
// to that paid plan only ends the promo, there is no new payment.
export const canContinueWithExistingPlan = (details, planId) => {
  if (!details || planId === 'free') return false;
  const paidTier = details.web_subscription?.tier;
  const currentRank = PLAN_RANK[details.tier?.toLowerCase()];
  return (
    details.is_promotional === true &&
    Boolean(paidTier) &&
    paidTier === planId &&
    currentRank !== undefined &&
    PLAN_RANK[planId] !== undefined &&
    PLAN_RANK[planId] < currentRank
  );
};
